// extracted by mini-css-extract-plugin
export default {"feature-span":"Kyx40cAL9f95Iv88Ka6D","featureSpan":"Kyx40cAL9f95Iv88Ka6D","feature-text":"kmtYHOiQCX86e0mmaka8","featureText":"kmtYHOiQCX86e0mmaka8"};